import configuration from "@utils/Config";
import { createEffect } from "effector";
import {
  restDeletionHandler,
  restDetailsHandler,
  restGetHandler,
  restPostHandler,
  restUpdateHandler,
  restUpdateMultipartHandler,
} from "@utils/rest/RestClient";
import { OfficeMembersResponseDto } from "@state/offices/dto/response/office.members.response.dto";
import { OfficePictureDeleteRequestDTO } from "@state/offices/dto/request/office.picture.delete.request.dto";
import { OfficeAliasRequestDto } from "@state/offices/dto/request/office.alias.request.dto";
import { Office, OfficesPreferences } from "@/type/core/offices/offices.types";
import { OfficePicturePriorityUpdateRequestDTO } from "@state/offices/dto/request/office.picture.priority.update.request.dto";
import { OfficesPreferencesUpdateRequestDTO } from "@state/offices/dto/request/office.preferences.update.request.dto";
import { OfficePictureDetailsResponseDto } from "@state/offices/dto/response/office.picture.details.response.dto";
import { PromotionCodeBody } from "@state/offices/dto/request/PromotionCodeBody";

const baseUrl = configuration.backendBaseUrl;
const officeUrl = baseUrl + "/ws/fo/office";
const membersUrl = "/members";
const expertsUrl = "/experts";
const pictureUrl = "/picture";
const signaturePriorityUrl = "/signaturePriority";
const scellementPriorityUrl = "/scellementPriority";
const officePreferencesUrl = baseUrl + "/ws/fo/officePreferences/";
const automaticRelaunch = "/automaticRelaunch";
const promoCodeUrl = "/code";

export const requestSearchMembersForOffice = createEffect({
  handler: restDetailsHandler<OfficeMembersResponseDto>(officeUrl, membersUrl),
});

export const requestSearchExpertsForOffice = createEffect({
  handler: restDetailsHandler<OfficeMembersResponseDto>(officeUrl, expertsUrl),
});

export const requestUpdateOfficePicture = createEffect({
  handler: restUpdateMultipartHandler<OfficePictureDetailsResponseDto>(
    officeUrl,
    pictureUrl,
  ),
});

export const requestDeleteOfficePicture = createEffect({
  handler: restDeletionHandler<OfficePictureDeleteRequestDTO>(
    officeUrl,
    pictureUrl,
  ),
});

export const requestUpdateOfficeSignatureDefaultPriority = createEffect({
  handler: restUpdateHandler<OfficePicturePriorityUpdateRequestDTO, void>(
    officeUrl,
    signaturePriorityUrl,
  ),
});

export const requestUpdateOfficeAlias = createEffect({
  handler: restUpdateHandler<OfficeAliasRequestDto, Office>(officeUrl),
});

export const requestUpdateOfficeScellementDefaultPriority = createEffect({
  handler: restUpdateHandler<OfficePicturePriorityUpdateRequestDTO, void>(
    officeUrl,
    scellementPriorityUrl,
  ),
});

export const requestGetOfficePreferences = createEffect({
  handler: restGetHandler<OfficesPreferences>(officePreferencesUrl),
});

export const requestUpdateOfficesPreferences = createEffect({
  handler: restPostHandler<OfficesPreferencesUpdateRequestDTO, void>(
    officePreferencesUrl,
  ),
});

export const requestDeleteAutomaticRelaunch = createEffect({
  handler: restDeletionHandler<void>(officePreferencesUrl, automaticRelaunch),
});

export const requestPostPromoCode = createEffect({
  handler: restPostHandler<PromotionCodeBody, void>(officeUrl, promoCodeUrl),
});
